<template>
  <div class="page-real-time" :style="{ height: pageHeight + 'px' }">
    <div class="real-time">
      <div class="option-box">
        <hm-select v-model="tower" placeholder="选择楼" @change="towerChange" :arrs="towers">
        </hm-select>
        <hm-select v-model="floor" placeholder="选择层" @change="floorChange" :arrs="floors">
        </hm-select>
        <hm-select v-model="room" placeholder="选择房" @change="roomChange" :arrs="rooms">
        </hm-select>
        <!-- <hm-select
          v-model="bed"
          placeholder="选择位置"
          @change="bedChange"
          :arrs="beds"
        >
        </hm-select> -->
        <el-input style="max-width: 120px; margin-right: 20px;" placeholder="雷达SN" v-model="searchSn"
          @input="searchChange"></el-input>

        <hm-button class="option-btn" @click="reset">重置</hm-button>
        <!-- <hm-button class="option-btn">筛选</hm-button> -->
        <!-- <hm-button class="option-btn" v-if="isManage">批量导出</hm-button> -->
      </div>
      <div class="monitor-info-title">
        <!-- <div class="check-box"></div> -->
        <div>设备SN</div>
        <div>楼</div>
        <div>层</div>
        <div>房间</div>
        <div>位置</div>
        <!-- <div>时间</div> -->
        <!-- <div v-if="isManage">呼吸心跳报告</div> -->
        <!-- <div>睡眠报告</div> -->
        <div>历史事件</div>
        <!-- <div v-if="isManage">导出表格</div> -->
        <!-- <div v-if="isManage">50ms数据</div> -->
      </div>
      <el-scrollbar style="height: 100%">
        <div class="list-box">
          <div class="monitor-info" :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in monitorList" :key="index">
            <!-- <div
              :class="
                item.isSelect ? 'check-box check-box-select' : 'check-box'
              "
              @click="selectList(item)"
            ></div> -->
            <div>{{ item.sn }}</div>
            <div>{{ item.towerName }}</div>
            <div>{{ item.floorName }}</div>
            <div>{{ item.roomName }}</div>
            <div>{{ item.location }}</div>
            <!-- <div class="time-select"> -->
            <!-- <el-select
                v-model="item.historyDate"
                placeholder="选择时间"
                @change="timeChange"
              >
                <el-option
                  v-for="itm in item.historyDates"
                  :key="itm.value"
                  :label="itm.label"
                  :value="itm.value"
                >
                </el-option>
              </el-select> -->
            <!-- <el-date-picker
                type="date"
                v-model="item.historyDate"
                placeholder="请选择日期"
                style="width: 130px"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker> -->
            <!-- </div> -->
            <!-- <div v-if="isManage">
              <span v-if="item.radarType == '1001'" @click="showReport(item)"
                >查看</span
              ><span v-if="item.radarType == '1002'">-</span>
            </div> -->
            <!-- <div>
              <span
                v-if="item.radarType == '1001'"
                @click="showSleepReport(item)"
                >查看</span
              ><span v-if="item.radarType == '1002'">-</span>
            </div> -->
            <div>
              <span @click="showHisEvent(item)">查看</span>
            </div>
            <!-- <div @click="exportList(item)" v-if="isManage">导出</div> -->
            <!-- <div @click="export50Data(item)" v-if="isManage">导出</div> -->
          </div>
        </div>
      </el-scrollbar>
      <el-pagination :page-size="pageSize" :total="deviceTotal" @current-change="devicePageChange"></el-pagination>
    </div>

    <!-- <div class="page-num-box">
      <div class="page-num-list">
        <div class="page-num" @click="activeIndex != 0 ? activeIndex-- : ''">
          <img :src="prevImg" />
        </div>
        <div
          class="page-num"
          :class="index == activeIndex ? 'page-num-active' : ''"
          v-for="(item, index) in pages"
          :key="index"
          @click="activeIndex = index"
        >
          <img :src="ellipsisImg" v-if="index == 2" />
          <span v-if="index != 2">{{ item.num }}</span>
        </div>
        <div class="page-num">
          <img :src="nextImg" @click="activeIndex != pages.length - 1 ? activeIndex++ : ''" />
        </div>
      </div>
    </div> -->

    <div class="mask-box" v-show="isMask" ref="mask">
      <div class="success-box" v-if="isSuccess">
        <div class="success-top">
          <div class="success-img">
            <img :src="successImg" />
          </div>
          <div class="success-text">导出成功</div>
        </div>
        <div class="success-bottom">
          <el-button class="success-btn" @click="exportOver">完成</el-button>
        </div>
      </div>

      <div class="report-box" v-if="isReport" v-loading="reportLoading">
        <div class="report-title-box">
          <div class="report-title">
            呼吸心跳报告
            <img :src="closeImg" class="report-close" @click="exportOver" />
          </div>
          <div class="report-info-box">
            <div class="report-info">床位：{{ reportData.bed }}</div>
            <div class="report-info">在床时长：{{ reportData.inBed }}</div>
            <div class="report-info">离床时长：{{ reportData.outBed }}</div>
            <div class="report-info">离床次数：{{ reportData.outBedNum }}</div>
            <div class="report-info">体动次数：{{ reportData.turnTimes }}</div>
          </div>
        </div>
        <div class="report-chart-box">
          <div class="report-chart" id="heartLine"></div>
          <div class="report-chart" id="breatherLine"></div>
          <div class="report-chart" id="turnNumBar"></div>
        </div>
        <div class="report-chart-box report-chart-box-last">
          <div class="report-chart" id="heartBar"></div>
          <div class="report-chart" id="breatherBar"></div>
          <div class="report-chart" id="getUpBar"></div>
        </div>
      </div>
    </div>

    <div class="mask-box" v-show="isSleepMask" ref="sleepMask">
      <div class="sleep-report-box" v-loading="sleepLoading">
        <div class="sleep-report-title-box">
          <div class="sleep-report-title">
            {{ sleepDate }} 睡眠报告
            <img :src="closeImg" class="report-close" @click="exportOver" />
          </div>
        </div>
        <div class="sleep-report-content">
          <div class="sleep-room-info">
            <div>房间：{{ sleepRoom }}</div>
            <div>位置：{{ sleepLocation }}</div>
            <div>监测时间段：{{ sleepMonitor }}</div>
          </div>
          <div class="sleep-report-content-box">
            <div class="content-box">
              <div class="sleep-chart-box">
                <!-- <div class="sleep-chart-title">呼吸心跳频率曲线</div> -->
                <h4>心率信息</h4>
                <div style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  ">
                  <img :src="require('../../assets/images/sleep/heart_line.png')"
                    style="height: 40px; margin-right: 10px" />
                  <span>平均心跳频率(次/分):{{
                    sleepReportContent.heartRate
                  }}</span>
                </div>
                <div class="sleep-chart" id="sleepHeartLine"></div>
              </div>
              <div class="sleep-chart-box">
                <h4>呼吸信息</h4>
                <div style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  ">
                  <img :src="
                    require('../../assets/images/sleep/breather_line.png')
                  " style="height: 40px; margin-right: 10px" />
                  <span>平均呼吸频率(次/分):{{ sleepReportContent.respRate }}</span>
                </div>

                <div class="sleep-chart" id="sleepBreatherLine"></div>
              </div>

              <div class="sleep-chart-box">
                <h4>睡眠质量曲线图</h4>
                <div class="sleep-chart" id="sleepQuality"></div>
              </div>
            </div>

            <div class="content-box">
              <div class="sleep-chart-box">
                <!-- <div class="sleep-chart-title">呼吸心跳频率统计</div> -->
                <h4>心率信息</h4>
                <div style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "></div>
                <div class="sleep-chart" id="sleepHeartBar"></div>
              </div>
              <div class="sleep-chart-box">
                <!-- <div class="sleep-chart-title">呼吸心跳频率统计</div> -->
                <h4>呼吸信息</h4>
                <div style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "></div>
                <div class="sleep-chart" id="sleepBreatherBar"></div>
              </div>
              <div class="sleep-chart-box"></div>
            </div>

            <div class="content-box">
              <div class="sleep-analyse-box">
                <div class="sleep-pie-box">
                  <div class="sleep-pie" id="sleepPie"></div>
                  <div class="sleep-pie-text">
                    <div style="height: 40px; display: flex; align-items: center">
                      <img :src="require('../../assets/images/sleep/clock.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 20px 0 10px">在床</span>
                      <span>{{ sleepReportContent.totalOnBedTime }}</span>
                    </div>
                    <div style="height: 40px; display: flex; align-items: center">
                      <img :src="require('../../assets/images/sleep/clock.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 20px 0 10px">清醒</span>
                      <span>{{ sleepReportContent.soberTime }}</span>
                    </div>
                    <div style="height: 40px; display: flex; align-items: center">
                      <img :src="require('../../assets/images/sleep/clock.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 20px 0 10px">深睡</span>
                      <span>{{ sleepReportContent.deepSleepTime }}</span>
                    </div>
                    <div style="height: 40px; display: flex; align-items: center">
                      <img :src="require('../../assets/images/sleep/clock.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 20px 0 10px">浅睡</span>
                      <span>{{ sleepReportContent.lightSleepTime }}</span>
                    </div>
                  </div>
                </div>

                <div class="bed-sleep-wake-box">
                  <div class="bed-sleep-wake">
                    <img :src="require('../../assets/images/sleep/go_bed.png')" style="width: 60px; height: 60px" />
                    <div style="margin: 5px 0">上床时间</div>
                    <div>{{ sleepReportContent.goToBedTime }}</div>
                  </div>
                  <div class="bed-sleep-wake">
                    <img :src="require('../../assets/images/sleep/sleep.png')" style="width: 60px; height: 60px" />
                    <div style="margin: 5px 0">入睡时间</div>
                    <div>{{ sleepReportContent.asleepTime }}</div>
                  </div>
                  <div class="bed-sleep-wake" v-if="sleepReportContent.ifGetUp">
                    <img :src="require('../../assets/images/sleep/reter.png')" style="width: 60px; height: 60px" />
                    <div style="margin: 5px 0">醒来时间</div>
                    <div>{{ sleepReportContent.wakeTime }}</div>
                  </div>
                  <div class="bed-sleep-wake">
                    <img :src="require('../../assets/images/sleep/get_up.png')" style="width: 60px; height: 60px" />
                    <div style="margin: 5px 0">起床时间</div>
                    <div>
                      {{
                      !sleepReportContent.ifGetUp
  ? sleepReportContent.upBedRemind
  : sleepReportContent.leaveBedTime
                      }}
                    </div>
                  </div>
                </div>
                <div style="flex: 1; overflow-y: auto">
                  <div class="leave-bed-times-box">
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">体动次数</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ sleepReportContent.bodyMovementNumbers }}
                      </div>
                    </div>
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">平均体动次数/小时</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ sleepReportContent.bodyMovementNumbersPerHour }}
                      </div>
                    </div>
                  </div>
                  <div class="leave-bed-times-box">
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">离床次数</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ sleepReportContent.leaveBedNumbers }}
                      </div>
                    </div>
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">离床总时间(min)</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ sleepReportContent.leaveTotalTime }}
                      </div>
                    </div>
                  </div>

                  <div class="leave-bed-times-box" v-for="(item, index) in sleepHisBedTimeList" :key="index">
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">离床时刻{{ index + 1 }}</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ item.start }}
                      </div>
                    </div>
                    <div class="leave-bed-times">
                      <img :src="require('../../assets/images/sleep/alarm.png')" style="width: 30px; height: 30px" />
                      <span style="margin: 0 30px 0 10px">回床时刻{{ index + 1 }}</span>
                      <div style="flex: 1; text-align: right; margin-right: 20px">
                        {{ item.end }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="sleep-bottom">- 已经到底啦 -</div> -->
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="hisDialog" :modal="false" style="backdrop-filter: blur(2px)">
      <div slot="title" style="display: flex; align-items: center">
        <img :src="require('../../assets/images/main/sleep.png')"
          style="width: 20px; height: 20px; margin-right: 10px" />
        历史事件
      </div>
      <div>
        <hm-select v-model="eventType" placeholder="请选择事件类型" :arrs="eventTypes" style="margin-right: 10px">
        </hm-select>
        <el-date-picker type="date" v-model="selectDate" placeholder="请选择触发日期" value-format="yyyy-MM-dd"
          :picker-options="eventPickerOptions" style="margin-right: 10px"></el-date-picker>
        <el-button type="primary" @click="resetHis">重置</el-button>
        <el-button type="primary" @click="hisSearch">搜索</el-button>
      </div>
      <div style="width: 100%; height: 50vh; overflow-y: auto; z-index: 1000">
        <el-table :data="hisEvents" v-loading="hisLoading">
          <el-table-column property="sn" label="设备"></el-table-column>
          <el-table-column property="eventInfo" label="历史事件" align="center"></el-table-column>
          <el-table-column property="dateTime" label="触发时间" align="right"></el-table-column>
        </el-table>
      </div>
      <el-pagination :page-size="10" :total="hisTotal" @current-change="pageChange"></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
// timeType  1,2,3
// 1，昨天，2，前天，3，过去七天
import pako from "pako";
import { Base64 } from "js-base64";
import {
  getBuilding,
  getFloor,
  getRoom,
  getBed,
  getDevice,
  queryHistoryData,
  querySleepData,
  query50Data,
  queryHisEvent,
  queryDownHistory,
} from "../../api/device";
import utils from "../../utils/utils";

import * as echarts from "echarts/core";
import {
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  MarkAreaComponent,
  VisualMapComponent,
  MarkLineComponent,
  LegendComponent,
} from "echarts/components";
import { LineChart, BarChart, PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { Loading } from "element-ui";

echarts.use([
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  MarkAreaComponent,
  VisualMapComponent,
  LineChart,
  BarChart,
  CanvasRenderer,
  MarkLineComponent,
  LegendComponent,
  PieChart,
]);

export default {
  name: "RealTime",
  data() {
    return {
      pageHeight: 0,
      isManage: false,
      userRooms: [],
      userFloors: [],
      userBuildings: [],
      tower: "",
      floor: "",
      room: "",
      bed: "",
      towers: [],
      floors: [],
      rooms: [],
      beds: [],
      allDevices: [],
      monitorList: [],

      historyList: [],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() >=
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
            time.getTime() <
            new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).setHours(0, 0, 0, 0)
            ).getTime()
          );
        },
      },

      eventPickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() >
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
            time.getTime() <
            new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).setHours(0, 0, 0, 0)
            ).getTime()
          );
        },
      },

      isMask: false,
      successImg: require("../../assets/images/main/success.svg"),
      selectTag: require("../../assets/images/main/selectTag.svg"),
      closeImg: require("../../assets/images/system/close.svg"),

      prevImg: require("../../assets/images/main/prev.svg"),
      nextImg: require("../../assets/images/main/next.svg"),
      ellipsisImg: require("../../assets/images/main/ellipsis.svg"),
      pages: [
        {
          num: 1,
          isActive: true,
        },
        {
          num: 2,
          isActive: false,
        },
        {
          num: 3,
          isActive: false,
        },
        {
          num: 4,
          isActive: false,
        },
        {
          num: 5,
          isActive: false,
        },
      ],
      activeIndex: 0,
      reportData: {},
      reportLoading: false,
      isReport: false,
      isSuccess: false,
      exportLoading: false,
      isSleepMask: false,
      sleepLoading: false,
      sleepDate: "",
      sleepRoom: "",
      sleepLocation: "",
      sleepMonitor: "",
      sleepReportContent: {},
      sleepHisBedTimeList: [],
      hisDialog: false,
      hisEvents: [],
      hisTotal: 0,
      currentPage: 1,
      currentData: {},
      eventType: "",
      // 1-检测到目标，2-目标消失，3-跌倒报警，4-报警解除
      eventTypes: [
        {
          label: "检测到目标",
          value: 1,
        },
        {
          label: "目标消失",
          value: 2,
        },
        {
          label: "跌倒报警",
          value: 3,
        },
        {
          label: "报警解除",
          value: 4,
        },
        {
          label: "滞留报警",
          value: 5
        }
      ],
      selectDate: "",
      hisLoading: false,
      deviceTotal: 0,
      currPage: 1,
      pageSize: 15,
      searchSn: ""
    };
  },
  created() {
    if (this.$store.getters.user.roleId != 1) {
      this.userRooms = this.$store.getters.user.roomList;
      this.userFloors = this.$store.getters.user.floorList;
      this.userBuildings = this.$store.getters.user.buildingList;
    } else {
      this.isManage = true;
    }
  },
  mounted() {
    this.initPageHeight();

    window.addEventListener("resize", this.initPageHeight, false);

    this.getTowers();
    this.getFloors();
    this.getRooms();
    this.getBeds();
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;

      echarts.getInstanceByDom(document.getElementById("sleepBreatherLine")) &&
        echarts
          .getInstanceByDom(document.getElementById("sleepBreatherLine"))
          .resize();
      echarts.getInstanceByDom(document.getElementById("sleepHeartLine")) &&
        echarts
          .getInstanceByDom(document.getElementById("sleepHeartLine"))
          .resize();
      echarts.getInstanceByDom(document.getElementById("sleepBreatherBar")) &&
        echarts
          .getInstanceByDom(document.getElementById("sleepBreatherBar"))
          .resize();
      echarts.getInstanceByDom(document.getElementById("sleepHeartBar")) &&
        echarts
          .getInstanceByDom(document.getElementById("sleepHeartBar"))
          .resize();
      echarts.getInstanceByDom(document.getElementById("sleepQuality")) &&
        echarts
          .getInstanceByDom(document.getElementById("sleepQuality"))
          .resize();
      echarts.getInstanceByDom(document.getElementById("sleepPie")) &&
        echarts.getInstanceByDom(document.getElementById("sleepPie")).resize();
    },

    searchChange() {
      this.getDeviceList()
    },

    // 获取楼列表
    getTowers() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (!this.isManage) {
              if (this.userBuildings.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              let obj = {
                value: item.id,
                label: item.name,
              };
              list.push(obj);
            }
          });
        }

        this.towers = list;
      });
    },

    reset() {
      this.currPage = 1;
      this.tower = "";
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.searchSn = ""
      this.getTowers();
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 选择楼
    towerChange(e) {
      this.currPage = 1;
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 获取层列表
    getFloors() {
      getFloor({
        page: 1,
        size: 9999,
        buildingId: this.tower,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (!this.isManage) {
              if (this.userFloors.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              let obj = {
                value: item.id,
                label: item.name,
              };
              list.push(obj);
            }
          });
        }

        this.floors = list;
      });
    },

    // 选择层
    floorChange(e) {
      this.currPage = 1;
      this.room = "";
      this.bed = "";
      this.getRooms();
      this.getBeds();
    },

    // 获取房列表
    getRooms() {
      getRoom({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            // 判断用户权限
            if (!this.isManage) {
              if (this.userRooms.indexOf(Number(item.id)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              item.value = item.id;
              item.label = item.name;
              list.push(item);
            }
          });
        }

        this.rooms = list;
      });
    },

    // 选择房
    roomChange(e) {
      this.currPage = 1;
      this.bed = "";
      this.getBeds();
    },

    // 获取位置列表
    getBeds() {
      getBed({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
        roomId: this.room,
      }).then((res) => {
        if (res.data.items.length > 0) {
          let list = [];
          res.data.items.forEach((item) => {
            // 判断用户权限
            if (!this.isManage) {
              if (this.userRooms.indexOf(Number(item.roomId)) != -1) {
                item.value = item.id;
                item.label = item.name;
                list.push(item);
              }
            } else {
              item.value = item.id;
              item.label = item.name;
              list.push(item);
            }
          });
          this.beds = list;
          this.getDeviceList();
        } else {
          this.beds = [];
          this.getDeviceList();
        }
      });
    },

    // 选择位置
    bedChange(e) {
      if (this.allDevices.length > 0) {
        let list = [];

        this.allDevices.forEach((item) => {
          if (item.bedId == this.bed) {
            list.push(item);
          }
        });

        this.monitorList = list;
      }
    },

    // 选择页码
    devicePageChange(e) {
      this.currPage = e;
      this.getDeviceList();
    },

    // 获取设备列表
    getDeviceList() {
      let obj = {
        page: this.currPage,
        size: this.pageSize,
        radarType: "1002", //  跌倒雷达
        id: this.$store.getters.user.id,
        sn: this.searchSn
      };
      if (this.tower) {
        obj.buildingId = this.tower;
      }
      // else if (!this.isManage) {
      //   obj.buildingId = this.userBuildings.join(',');
      // }

      if (this.floor) {
        obj.floorId = this.floor;
      }
      // else if (!this.isManage) {
      //   obj.floorId = this.userFloors.join(',');
      // }

      if (this.room) {
        obj.roomId = this.room;
      } else if (!this.isManage) {
        // obj.roomId = this.userRooms.join(",");
      }
      getDevice(obj).then((res) => {
        console.log("获取设备列表", res);
        this.deviceTotal = res.data.total;
        if (res.data.records.length > 0) {
          let list = [];
          res.data.records.forEach((item) => {
            this.beds.forEach((itm) => {
              if (item.bedId == itm.id) {
                item.historyDate = "";
                item.historyDates = [
                  {
                    value: "1",
                    label: "昨天",
                  },
                  {
                    value: "2",
                    label: "前天",
                  },
                  {
                    value: "3",
                    label: "大前天",
                  },
                ];
                item.isSelect = false;
                item.towerName = itm.buildingName;
                item.floorName = itm.floorName;
                item.roomName = itm.roomName;
                item.location = itm.name;


              }
            });
            list.push(item);
          });
          this.allDevices = res.data.items;

          this.monitorList = list;
        } else {
          this.allDevices = [];
          this.monitorList = [];
        }
      });
    },

    // 选择列表
    selectList(data) {
      data.isSelect = !data.isSelect;

      this.monitorList = JSON.parse(JSON.stringify(this.monitorList));
    },

    // 时间选择
    timeChange(e) {
      this.monitorList = JSON.parse(JSON.stringify(this.monitorList));
    },

    export2Excel(fileName, list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("vendor/Export2Excel");
        const tHeader = [
          // "雷达SN码",
          "雷达IP",
          "雷达端口",
          "1分钟内呼吸频率均值",
          "1分钟内心跳频率均值",
          "1分钟内呼吸幅度均值",
          "1分钟内心跳幅度均值",
          "1分钟内呼吸频率标准差",
          "1分钟内心跳频率标准差",
          "1分钟内呼吸幅度最大值和最小值的差",
          "1分钟内心跳幅度最大值和最小值的差",
          "有无人标志",
          "体动",
          "数据上报时间",
        ];
        const filterVal = [
          // "sn",
          "ip",
          "port",
          "breathFreqAvg",
          "heartFreqAvg",
          "breathAmpAvg",
          "heartAmpAvg",
          "breathFreqStd",
          "heartFreqStd",
          "breathDiff",
          "heartDiff",
          "hasPeople",
          "hasMove",
          "dateTime",
        ];
        const data = this.formatJson(filterVal, list);
        for (let i = 0; i < data.length / 500000; i++) {
          export_json_to_excel(
            tHeader,
            data.slice(500000 * i, 500000 * (i + 1)),
            fileName
          );
        }
        // try {
        //   export_json_to_excel(tHeader, data, fileName);
        // } catch (error) {
        //   console.log('导出表格失败',error)
        // }
      });
    },

    export50Excel(fileName, list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("vendor/Export2Excel");
        const tHeader = [
          "呼吸频率",
          "心跳频率",
          "呼吸相位",
          "心跳相位",
          "有无人",
          "体动次数",
          "离床次数",
          "时间",
        ];
        const filterVal = [
          "freqBreath",
          "freqHeart",
          "phaseBreath",
          "phaseHeart",
          "people",
          "turnTimes",
          "leaveTimes",
          "dateTime",
        ];
        const data = this.formatJson(filterVal, list);
        for (let i = 0; i < data.length / 500000; i++) {
          export_json_to_excel(
            tHeader,
            data.slice(500000 * i, 500000 * (i + 1)),
            fileName
          );
        }
        // try {
        //   export_json_to_excel(tHeader, data, fileName);
        // } catch (error) {
        //   console.log('导出表格失败',error)
        // }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    // 查看报告
    showReport(data) {
      this.reportData.bed = data.location;
      if (data.historyDate == "" || data.historyDate == null) {
        this.$message("请选择时间");
      } else {
        this.isSuccess = false;
        this.isReport = true;
        this.isMask = true;
        document.getElementsByTagName("body")[0].appendChild(this.$refs.mask);
        document.getElementById("app").style.filter = "blur(2px)";
        this.reportLoading = true;
        queryHistoryData({
          sn: data.sn,
          // timeType: data.historyDate,
          reportDate: data.historyDate,
          radarType: data.radarType,
          startTime: data.startTime,
          endTime: data.endTime,
          pageNum: 1,
          pageSize: 10000000,
        })
          .then((res) => {
            // let baseData = Base64.toUint8Array(res.data.items);
            // let pakoData = pako.ungzip(baseData, { to: "string" });
            let pakoData = this.unzip(res.data.items);
            let data = JSON.parse(pakoData);

            // console.log('报告数据数量',data.length)

            if (data.length > 0) {
              let heartLine = {
                x: [],
                y: [],
              };
              let heartBar = {
                x: [],
                y: [],
              };
              let breatherLine = {
                x: [],
                y: [],
              };
              let breatherBar = {
                x: [],
                y: [],
              };
              let getUp = {
                x: [],
                y: [],
              };
              let turnNum = {
                x: [],
                y: [],
              };
              data.forEach((item, index) => {
                // 呼吸心跳频率
                if (index % 1200 == 0) {
                  heartLine.x.push(utils.formatTime(new Date(item.dateTime)));
                  heartLine.y.push(parseInt(item.freqHeart * 60));

                  breatherLine.x.push(
                    utils.formatTime(new Date(item.dateTime))
                  );
                  breatherLine.y.push(parseInt(item.freqBreath * 60));
                }

                // 呼吸心跳次数
                if (index == 0) {
                  heartBar.x.push(parseInt(item.freqHeart * 60));
                  heartBar.y.push(1);

                  breatherBar.x.push(parseInt(item.freqBreath * 60));
                  breatherBar.y.push(1);
                } else {
                  if (heartBar.x.indexOf(parseInt(item.freqHeart * 60)) == -1) {
                    heartBar.x.push(parseInt(item.freqHeart * 60));
                    heartBar.y.push(1);
                  } else {
                    heartBar.y[
                      heartBar.x.indexOf(parseInt(item.freqHeart * 60))
                    ] += 1;
                  }

                  if (
                    breatherBar.x.indexOf(parseInt(item.freqBreath * 60)) == -1
                  ) {
                    breatherBar.x.push(parseInt(item.freqBreath * 60));
                    breatherBar.y.push(1);
                  } else {
                    breatherBar.y[
                      breatherBar.x.indexOf(parseInt(item.freqBreath * 60))
                    ] += 1;
                  }
                }
              });

              // 起床次数、体动次数
              for (let i = 0; i < 24; i++) {
                getUp.x.push(`${i}:00-${i + 1}:00`);
                getUp.y.push(0);

                turnNum.x.push(`${i}:00-${i + 1}:00`);
                turnNum.y.push(0);

                let arr = [];
                data.forEach((item) => {
                  if (
                    new Date(item.dateTime).getHours() == i &&
                    item.getUp == 1
                  ) {
                    getUp.y[i] += 1;
                  }

                  if (new Date(item.dateTime).getHours() == i) {
                    arr.push(item.turnTimes);
                    // turnNum.y[i] = item.turn_times;
                  }
                });
                turnNum.y[i] = this.maxMin(arr);
              }

              this.reportData.outBedNum = 0;
              getUp.y.forEach((item) => {
                this.reportData.outBedNum += item;
              });

              this.reportLoading = false;
              this.reportData.turnTimes = data[data.length - 1].turnTimes;
              this.reportData.inBed = this.formatTime(
                parseInt(data[data.length - 1].peopleTimeHave * 0.05)
              );
              this.reportData.outBed = this.formatTime(
                parseInt(data[data.length - 1].peopleTimeLeave * 0.05)
              );

              this.initLine("heartLine", "心跳频率", heartLine);
              this.initLine("breatherLine", "呼吸频率", breatherLine);

              this.initBar("heartBar", "心跳频率", this.arrSort(heartBar));
              this.initBar(
                "breatherBar",
                "呼吸频率",
                this.arrSort(breatherBar)
              );

              this.initNumBar("getUpBar", "起床次数", getUp);
              this.initNumBar("turnNumBar", "体动次数", turnNum);
            } else {
              this.reportLoading = false;
              this.$message("无数据");
            }
          })
          .catch((err) => {
            this.reportLoading = false;
          });
      }
    },

    // 解压
    unzip(b64Data) {
      var strData = atob(b64Data);
      // Convert binary string to character-number array
      var charData = strData.split("").map(function (x) {
        return x.charCodeAt(0);
      });
      // Turn number array into byte-array
      var binData = new Uint8Array(charData);
      // // unzip
      var data = pako.inflate(binData);
      // Convert gunzipped byteArray back to ascii string:
      // strData = String.fromCharCode.apply(null, new Uint16Array(data));
      let array = new Uint16Array(data);
      var res = "";
      var chunk = 8 * 1024;
      var i;
      for (i = 0; i < array.length / chunk; i++) {
        res += String.fromCharCode.apply(
          null,
          array.slice(i * chunk, (i + 1) * chunk)
        );
      }
      res += String.fromCharCode.apply(null, array.slice(i * chunk));
      strData = res;
      return strData;
    },

    // 二维数组排序
    arrSort(arr) {
      let m, n;
      for (let i = 0; i < arr.x.length; i++) {
        for (let j = 0; j < arr.x.length; j++) {
          if (arr.x[i] < arr.x[j]) {
            m = arr.x[j];
            arr.x[j] = arr.x[i];
            arr.x[i] = m;

            n = arr.y[j];
            arr.y[j] = arr.y[i];
            arr.y[i] = n;
          }
        }
      }
      return arr;
    },

    // 计算最大、最小值并取差
    maxMin(data) {
      if (data.length > 0) {
        data.sort((a, b) => {
          return a - b;
        });

        return data[data.length - 1] - data[0];
      } else {
        return 0;
      }
    },

    // 时间处理
    formatTime(time) {
      let hour = parseInt(time / 3600);
      let min = parseInt((time % 3600) / 60);
      let sec = (time % 3600) % 60;

      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }

      return `${hour}:${min}:${sec}`;
    },

    exportList(data) {
      if (data.historyDate == "" || data.historyDate == null) {
        this.$message("请选择时间");
      } else {
        let tip = this.$message({
          message: "导出中，请稍候",
          iconClass: "el-icon-loading el-message__icon",
          duration: 0,
        });
        queryHistoryData({
          sn: data.sn,
          radarType: data.radarType,
          // timeType: data.historyDate,
          reportDate: data.historyDate,
          startTime: data.startTime,
          endTime: data.endTime,
          pageNum: 1,
          pageSize: 10000000,
        })
          .then((res) => {
            tip.close();
            // let baseData = Base64.toUint8Array(res.data.items);
            // let pakoData = pako.ungzip(baseData, { to: "string" });
            let pakoData = this.unzip(res.data.items);
            let dataList = JSON.parse(pakoData);
            if (dataList.length > 0) {
              dataList.forEach((item) => {
                item.dateTime = utils.formatTime(new Date(item.dateTime));

                item.inBedTime = this.formatTime(
                  parseInt(item.peopleTimeHave * 0.05)
                );
                item.outBedTime = this.formatTime(
                  parseInt(item.peopleTimeLeave * 0.05)
                );
              });
            }

            this.export2Excel(
              `${data.roomName}-${data.location}-${data.name}`,
              dataList
            );

            this.isReport = false;
            this.isSuccess = true;
            this.isMask = true;
            document
              .getElementsByTagName("body")[0]
              .appendChild(this.$refs.mask);
            document.getElementById("app").style.filter = "blur(2px)";
          })
          .catch((err) => {
            tip.close();
          });
      }
    },

    exportOver() {
      if (this.isMask) {
        document.getElementsByTagName("body")[0].removeChild(this.$refs.mask);
      }

      if (this.isSleepMask) {
        this.sleepReportContent = {};
        this.sleepHisBedTimeList = [];
        echarts.getInstanceByDom(
          document.getElementById("sleepBreatherLine")
        ) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepBreatherLine"))
            .dispose();
        echarts.getInstanceByDom(document.getElementById("sleepHeartLine")) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepHeartLine"))
            .dispose();
        echarts.getInstanceByDom(document.getElementById("sleepBreatherBar")) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepBreatherBar"))
            .dispose();
        echarts.getInstanceByDom(document.getElementById("sleepHeartBar")) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepHeartBar"))
            .dispose();
        echarts.getInstanceByDom(document.getElementById("sleepQuality")) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepQuality"))
            .dispose();
        echarts.getInstanceByDom(document.getElementById("sleepPie")) &&
          echarts
            .getInstanceByDom(document.getElementById("sleepPie"))
            .dispose();
        document
          .getElementsByTagName("body")[0]
          .removeChild(this.$refs.sleepMask);
      }
      this.isSuccess = false;
      this.isReport = false;
      this.isMask = false;
      this.isSleepMask = false;

      document.getElementById("app").style.filter = "blur(0px)";
    },

    initLine(dom, yName, data, isShowX, markArea, visualMap) {
      console.log(data);
      var chartDom = document.getElementById(dom);
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          name: "时间",
          type: "category",
          data: data.x,
          axisLabel: {
            show: isShowX ? isShowX : false,
          },
        },
        grid: {
          bottom: 15,
          top: 30,
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            minValueSpan: 10,
          },
        ],
        yAxis: {
          name: yName,
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: data.y,
            type: "line",
            markArea: markArea ? markArea : {},
            symbol: "none",
            // areaStyle: {
            //   color: '#9eccab'
            // }
          },
        ],
      };

      if (visualMap) {
        option.visualMap = visualMap;
      }

      myChart.setOption(option);
    },

    initQuaLine(dom, yName, data) {
      var chartDom = document.getElementById(dom);
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          name: "",
          type: "category",
          data: data.x,
        },
        grid: {
          bottom: "15%",
          top: "20%",
          right: "15%",
        },
        dataZoom: [
          {
            type: "inside",
            minValueSpan: 10,
          },
        ],
        yAxis: {
          name: yName,
          type: "value",
          min: -1,
          max: 1,
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: data.y,
            type: "line",
            symbol: "none",

            markLine: {
              data: [
                {
                  yAxis: 0.4,
                  lineStyle: {
                    color: "red",
                    type: "solid",
                  },
                  label: {
                    position: "end",
                    formatter: "深睡门限0.4",
                  },
                },
                {
                  label: {
                    position: "end",
                    formatter: "浅睡门限0.8",
                  },
                  yAxis: 0.8,
                  lineStyle: {
                    color: "#f3d07a",
                    type: "solid",
                  },
                },
              ],
            },
            // areaStyle: {
            //   color: '#9eccab'
            // }
          },
        ],
      };

      myChart.setOption(option);
    },

    initBar(dom, xName, data, range) {
      if (!range) {
        range = {
          start: 0,
          end: 100,
        };
      }
      var chartDom = document.getElementById(dom);
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          name: xName,
          nameGap: 2,
          type: "category",
          data: data.x,
          nameTextStyle: {
            rich: {
              a: {},
            },
          },
        },
        grid: {
          bottom: 15,
          top: 30,
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            startValue: range.start,
            endValue: range.end,
            minValueSpan: 10,
          },
        ],
        yAxis: {
          name: "出现次数",
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: data.y,
            type: "bar",
          },
        ],
      };

      myChart.setOption(option);
    },

    initNumBar(dom, yName, data) {
      var chartDom = document.getElementById(dom);
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          name: "时间",
          type: "category",
          data: data.x,
          axisLabel: {
            show: false,
          },
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
            minValueSpan: 10,
          },
        ],
        yAxis: {
          name: yName,
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: data.y,
            type: "bar",
          },
        ],
      };

      myChart.setOption(option);
    },

    initPie(dom, data) {
      var chartDom = document.getElementById(dom);
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: "vertical",
        //   top: "middle",
        //   left: "right"
        // },
        grid: {
          top: 0,
          bottom: 0,
        },
        series: [
          {
            name: "睡眠百分比",
            type: "pie",
            radius: "50%",
            data: data,
          },
        ],
      };

      myChart.setOption(option);
    },

    // 50ms数据
    export50Data(data) {
      if (data.historyDate == "" || data.historyDate == null) {
        this.$message("请选择时间");
      } else {
        let tip = this.$message({
          message: "导出中，请稍候",
          iconClass: "el-icon-loading",
          duration: 0,
        });
        query50Data({
          sn: data.sn,
          radarType: data.radarType,
          // timeType: data.historyDate,
          reportDate: data.historyDate,
          startTime: data.startTime,
          endTime: data.endTime,
          pageNum: 1,
          pageSize: 10000000,
        })
          .then((res) => {
            tip.close();
            // let baseData = Base64.toUint8Array(res.data.items);
            // let pakoData = pako.ungzip(baseData, { to: "string" });
            let pakoData = this.unzip(res.data.items);
            let dataList = JSON.parse(pakoData);
            if (dataList.length > 0) {
              dataList.forEach((item) => {
                item.dateTime = utils.formatTime(new Date(item.dateTime));

                // item.inBedTime = this.formatTime(
                //   parseInt(item.peopleTimeHave * 0.05)
                // );
                // item.outBedTime = this.formatTime(
                //   parseInt(item.peopleTimeLeave * 0.05)
                // );
              });
            }

            this.export50Excel(
              `${data.roomName}-${data.location}-${data.name}`,
              dataList
            );

            this.isReport = false;
            this.isSuccess = true;
            this.isMask = true;
            document
              .getElementsByTagName("body")[0]
              .appendChild(this.$refs.mask);
            document.getElementById("app").style.filter = "blur(2px)";
          })
          .catch((err) => {
            tip.close();
          });
      }
    },

    // 睡眠报告
    showSleepReport(data) {
      if (data.historyDate == "" || data.historyDate == null) {
        this.$message("请选择时间");
      } else {
        this.sleepLoading = true;
        this.isSleepMask = true;
        document
          .getElementsByTagName("body")[0]
          .appendChild(this.$refs.sleepMask);
        document.getElementById("app").style.filter = "blur(2px)";

        this.sleepRoom = data.roomName;
        this.sleepLocation = data.location;
        this.sleepMonitor = `${data.startTime}~${data.endTime}`;

        querySleepData({
          // timeType: data.historyDate,
          reportDate: data.historyDate,
          sn: data.sn,
          // sn: "500520",
        })
          .then((res) => {
            this.sleepLoading = false;

            console.log("查询睡眠报告", res);
            res.data.medicineSleepQuality.respRate = parseFloat(
              res.data.medicineSleepQuality.breathingRate
            ).toFixed(1);
            res.data.medicineSleepQuality.heartRate = parseFloat(
              res.data.medicineSleepQuality.heartbeatRate
            ).toFixed(1);
            res.data.medicineSleepQuality.awakeningRate = parseFloat(
              res.data.medicineSleepQuality.awakeningRate
            ).toFixed(1);
            res.data.medicineSleepQuality.lightSleepRate = parseFloat(
              res.data.medicineSleepQuality.lightSleepRate
            ).toFixed(1);
            res.data.medicineSleepQuality.deepSleepRate = parseFloat(
              res.data.medicineSleepQuality.deepSleepRate
            ).toFixed(1);
            res.data.medicineSleepQuality.bodyMovementNumbersPerHour =
              parseFloat(
                res.data.medicineSleepQuality.bodyMovementNumbersPerHour
              ).toFixed(1);
            this.sleepReportContent = res.data.medicineSleepQuality;
            this.sleepReportContent.goToBedTime = utils
              .formatTime(new Date(this.sleepReportContent.goToBedTime))
              .slice(10, 16);
            this.sleepReportContent.asleepTime = utils
              .formatTime(new Date(this.sleepReportContent.asleepTime))
              .slice(10, 16);
            this.sleepReportContent.wakeTime = this.sleepReportContent.wakeTime
              ? utils
                .formatTime(new Date(this.sleepReportContent.wakeTime))
                .slice(10, 16)
              : this.sleepReportContent.wakeTime;
            this.sleepReportContent.leaveBedTime = this.sleepReportContent
              .leaveBedTime
              ? utils
                .formatTime(new Date(this.sleepReportContent.leaveBedTime))
                .slice(10, 16)
              : this.sleepReportContent.leaveBedTime;

            this.sleepReportContent.totalOnBedTime = `${parseInt(
              this.sleepReportContent.totalOnBedTime / 3600
            )}时${parseInt(this.sleepReportContent.totalOnBedTime / 60) % 60
              }分`;
            // this.sleepReportContent.leaveTotalTime = `${parseInt(
            //   this.sleepReportContent.leaveTotalTime / 3600
            // )}时${
            //   parseInt(this.sleepReportContent.leaveTotalTime / 60) % 60
            // }分`;
            this.sleepReportContent.leaveTotalTime = `${parseInt(this.sleepReportContent.leaveTotalTime) / 60
              }分`;
            this.sleepReportContent.soberTime = `${parseInt(
              this.sleepReportContent.soberTime / 3600
            )}时${parseInt(this.sleepReportContent.soberTime / 60) % 60}分`;
            this.sleepReportContent.deepSleepTime = `${parseInt(
              this.sleepReportContent.deepSleepTime / 3600
            )}时${parseInt(this.sleepReportContent.deepSleepTime / 60) % 60}分`;
            this.sleepReportContent.lightSleepTime = `${parseInt(
              this.sleepReportContent.lightSleepTime / 3600
            )}时${parseInt(this.sleepReportContent.lightSleepTime / 60) % 60
              }分`;

            this.sleepHisBedTimeList =
              res.data.medicineSleepQuality.leaveBedIntervals;
            if (this.sleepHisBedTimeList.length > 0) {
              this.sleepHisBedTimeList.forEach((item) => {
                item.start = utils
                  .formatTime(new Date(item.start))
                  .slice(10, 16);
                item.end = utils.formatTime(new Date(item.end)).slice(10, 16);
              });
            }
            let date = res.data.medicineSleepQuality.reportDate.split("-");
            this.sleepDate = `${date[0]}年${date[1]}月${date[2]}日`;

            let pieData = [
              {
                value: this.sleepReportContent.lightSleepRate,
                name: "浅睡眠",
              },
              {
                value: this.sleepReportContent.deepSleepRate,
                name: "深睡眠",
              },
              {
                value: this.sleepReportContent.awakeningRate,
                name: "觉醒",
              },
            ];
            this.initPie("sleepPie", pieData);

            let x = [];
            let y1 = [];
            let y2 = [];
            if (res.data.breathAndHeartInfoList.length > 0) {
              res.data.breathAndHeartInfoList.forEach((item) => {
                x.push(`${item.hour}时${item.minute}分`);
                y1.push(item.respRate);
                y2.push(item.heartRate);
              });
            }

            this.initLine(
              "sleepBreatherLine",
              "呼吸频率(次/分钟)",
              { x: x, y: y1 },
              true
            );

            let markArea = {
              label: {
                position: "right",
              },
              data: [
                [
                  {
                    name: "偏低",
                    yAxis: 0,
                    itemStyle: {
                      color: "rgba(0,0,0,0.2)",
                    },
                  },
                  {
                    yAxis: 60,
                  },
                ],
                [
                  {
                    name: "正常",
                    yAxis: 60,
                  },
                  {
                    yAxis: 100,
                  },
                ],
                [
                  {
                    name: "偏高",
                    yAxis: 100,
                    itemStyle: {
                      color: "rgba(255,255,255,0)",
                    },
                  },
                  {
                    yAxis: 200,
                  },
                ],
              ],
              silent: true,
            };

            let visualMap = {
              type: "piecewise",
              pieces: [
                { gt: 100, lte: 200, color: "yellow" },
                { gt: 60, lte: 100, color: "blue" },
                { gt: 0, lte: 60, color: "red" },
              ],
              show: false,
            };

            this.initLine(
              "sleepHeartLine",
              "心跳频率(次/分钟)",
              { x: x, y: y2 },
              true,
              markArea,
              visualMap
            );

            let [qx, qy] = [[], []];

            if (res.data.sleepQualityInfo.length > 0) {
              res.data.sleepQualityInfo.forEach((item, index) => {
                qy.push(item.saveSleepQualityData);
                qx.push(item.showTime);
              });
            }

            this.initQuaLine(
              "sleepQuality",
              "睡眠质量指数",
              { x: qx, y: qy },
              true
            );

            let heartBarData = {
              x: [],
              y: [],
            };
            for (let i = 0; i < res.data.heartList.length; i++) {
              heartBarData.x.push(i + 1);
            }
            heartBarData.y = res.data.heartList;
            this.initBar(
              "sleepHeartBar",
              "{a|心跳频率\n(次/分钟)}",
              heartBarData,
              {
                start: "40",
                end: "120",
              }
            );

            let breatherBarData = {
              x: [],
              y: [],
            };
            for (let i = 0; i < res.data.breatheList.length; i++) {
              breatherBarData.x.push(i + 1);
            }
            breatherBarData.y = res.data.breatheList;
            this.initBar(
              "sleepBreatherBar",
              "{a|呼吸频率\n(次/分钟)}",
              breatherBarData,
              { start: "1", end: "30" }
            );
          })
          .catch((err) => {
            this.sleepLoading = false;
          });
      }
    },

    // 历史事件
    showHisEvent(data) {
      this.hisEvents = [];
      this.hisTotal = 0;
      this.hisDialog = true;
      this.currentPage = 1;
      this.currentData = data;
      this.eventType = "";
      this.selectDate = "";

      this.getHisEvent();
    },

    getHisEvent() {
      let obj = {
        sn: this.currentData.sn,
        size: 10,
        page: this.currentPage,
      };
      if (this.selectDate) {
        obj.selectDate = this.selectDate;
      }
      if (this.eventType) {
        obj.eventType = this.eventType;
      }
      this.hisLoading = true;
      queryDownHistory(obj)
        .then((res) => {
          this.hisLoading = false;
          this.hisTotal = res.data.total;
          this.hisEvents = res.data.page;

          if (this.hisEvents.length > 0) {
            this.hisEvents.forEach((item) => {
              item.dateTime = utils.formatTime(new Date(item.dateTime));
            });
          }
        })
        .catch(() => {
          this.hisLoading = false;
        });
    },

    resetHis() {
      this.eventType = "";
      this.selectDate = "";
    },

    hisSearch() {
      this.currentPage = 1;
      this.getHisEvent();
      console.log(this.eventType, this.selectDate);
    },

    pageChange(e) {
      this.currentPage = e;

      this.getHisEvent();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
    if (this.isMask || this.isSleepMask) {
      this.exportOver();
    }
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-real-time {
  width: 100%;
  // padding: 70px 60px 0 60px;
  // padding: 5.5vh 3vw 0 3vw;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .real-time {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 40px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .option-box {
      display: flex;
      justify-content: center;

      .option-btn {
        width: 100px;
        height: 40px;
        margin-right: 36px;
        margin-left: 0;
      }
    }

    .monitor-info-title {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 40px;
      padding-right: 50px;

      // div:nth-child(1) {
      //   width: 92px;
      //   text-align: center;
      // }
      div:nth-child(1),
      div:nth-child(2),
      div:nth-child(3),
      div:nth-child(4),
      div:nth-child(5),
      div:nth-child(6),
      div:nth-child(7),
      div:nth-child(8) {
        flex: 1;
        text-align: center;
      }

      .check-box {
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border: 1px solid #c9d5ef;
        background: #fff;
        margin: 0 50px 0 25px;
      }
    }

    .list-box {
      flex: 1;

      .monitor-info {
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 15px;
        padding-right: 50px;

        // div:nth-child(1) {
        //   width: 92px;
        //   text-align: center;
        // }
        div:nth-child(1),
        div:nth-child(2),
        div:nth-child(3),
        div:nth-child(4),
        div:nth-child(5),
        div:nth-child(6),
        div:nth-child(7),
        div:nth-child(8) {
          flex: 1;
          text-align: center;
          cursor: pointer;
        }

        div:last-child {
          // color: #26415f;
          color: #0553fd;
        }

        .check-box {
          width: 25px;
          height: 25px;
          box-sizing: border-box;
          border: 1px solid #c9d5ef;
          background: #fff;
          margin: 0 50px 0 25px;
        }

        .check-box-select {
          background: #1d63fd;
        }
      }
    }
  }

  .page-num-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;

    .page-num-list {
      height: 60px;
      display: flex;
      align-items: center;

      .page-num {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #26415f;
      }

      .page-num-active {
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #c9d5ef;
        border-radius: 8px;
      }
    }
  }
}
</style>
<style>
.el-select {
  width: 205px;
  margin-right: 36px;
}

.el-input__inner {
  border-color: 1px solid#c9d5e7;
  border-radius: 8px;
}

.time-select .el-select {
  width: 100px;
  margin: 0 auto;
}

.time-select .el-input__inner {
  font-size: 13px;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}

.mask-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(33, 64, 132, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.success-box {
  width: 211px;
  height: 204px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.success-top {
  flex: 1;
  overflow: hidden;
}

.success-bottom {
  height: 72px;
  background: #ebf0fc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.success-btn {
  width: 133px;
  height: 40px;
  font-size: 14px;
  color: #fff;
  background: #1d63fd;
  border-radius: 8px;
  border: none;
}

.success-btn:hover {
  background: #1d63fd;
  color: #fff;
}

.success-img {
  width: 48px;
  height: 48px;
  margin: 23px auto 17px;
}

.success-text {
  text-align: center;
  font-size: 20px;
}

.report-box {
  width: 90%;
  height: 90%;
  /* background: #f5f9ff; */
  background: #efefef;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sleep-report-box {
  width: 95vw;
  height: 95vh;
  /* background: #f5f9ff; */
  /* background: #efefef; */
  background: #e5faff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* font-family: '华文行楷'; */
}

.report-close {
  position: absolute;
  top: 20px;
  right: 25px;
}

.report-title-box {
  width: 100%;
  height: 100px;
  background: #fff;
}

.report-title {
  width: 100%;
  height: 70px;
  line-height: 70px;
  font-size: 25px;
  position: relative;
  text-align: center;
}

.report-info-box {
  height: 30px;
  padding-left: 25px;
  display: flex;
}

.report-info {
  width: 150px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  margin-right: 20px;
}

.report-chart-box {
  flex: 1;
  padding: 30px 50px 0;
  display: flex;
  justify-content: space-between;
}

.report-chart-box-last {
  margin-bottom: 30px;
}

.report-chart {
  flex: 1;
  height: 100%;
  margin-right: 30px;
  background: #fff;
  border-radius: 8px;
}

.report-chart:last-child {
  margin-right: 0;
}

/* 睡眠报告 */
.sleep-report-title-box {
  width: 100%;
  height: 70px;
  background: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sleep-report-title {
  /* margin-top: 72px; */
  font-size: 25px;
}

.sleep-room-info {
  margin: 20px 5%;
  display: flex;
  justify-content: space-between;
}

.sleep-room-info div {
  font-size: 18px;
  /* margin-right: 163px; */
}

.sleep-chart-title {
  font-size: 14px;
  /* margin: 0 0 40px 25px; */
}

.sleep-report-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sleep-report-content::-webkit-scrollbar {
  display: none;
}

.sleep-report-content-box {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  flex: 1;
  /* overflow-y: auto; */
  overflow: hidden;
}

.content-box {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-box:nth-child(2) {
  margin: 0 10px;
}

.sleep-chart-box {
  /* margin: 0 100px 50px; */
  /* display: flex; */
  /* height: 250px; */
  flex: 1;
  display: flex;
  flex-direction: column;
}

.sleep-chart {
  flex: 1;
  /* height: 250px; */
  /* background: #fff; */
  border-radius: 12px;
}

h4 {
  margin: 10px 0;
}

.sleep-analyse-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sleep-pie-box {
  width: 100%;
  height: 250px;
  display: flex;
}

.sleep-pie {
  width: 60%;
  max-width: 60%;
  height: 250px;
}

.sleep-pie-text {
  width: 40%;
  min-width: 40%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bed-sleep-wake-box {
  display: flex;
  margin-bottom: 20px;
}

.bed-sleep-wake {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.leave-bed-times-box {
  display: flex;
  padding: 0 25px;
  box-sizing: border-box;
  margin: 5px 0;
  font-size: 14px;
}

.leave-bed-times {
  flex: 1;
  display: flex;
  height: 40px;
  align-items: center;
  /* background: #e4f3e4; */
}

.sleep-bottom {
  font-size: 12px;
  text-align: center;
  margin: 10px 0;
}

.sleep-analyse {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.sleep-analyse img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.sleep-analyse-content {
  /* margin: 0 140px; */
  font-size: 16px;
  display: flex;
}

.sleep-analyse-content div {
  height: 50px;
  flex: 1;
  display: flex;
  align-items: center;
  background: #fff;
}

.sleep-analyse-content img {
  width: 28px;
  height: 28px;
  margin: 0 20px;
}

.sleep-analyse-content-img {
  display: block;
  width: 28px;
  height: 28px;
  margin: 0 20px;
}

.sleep-analyse-content-grey div {
  background: #efefef;
}

.sleep-analyse-content-left {
  margin-right: 60px;
}

.sleep-analyse-content-radius {
  flex: 1;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/report/historyDown.vue